import Index from "./page/index.vue";

import Pro3d from "./page/newproject/3d.vue"
import Proailiuxing from "./page/newproject/aiLiuxing.vue"
import Probookclub from "./page/newproject/bookclub.vue"
import Proclub from "./page/newproject/club.vue"
import Prodatapr from "./page/newproject/datapr.vue"
import Prodesgin from "./page/newproject/desgin.vue"
import Prointenet from "./page/newproject/intenet.vue"

import Supply from "./page/supply.vue"

import Solution from "./page/solution/fashion.vue"
import Fashion from "./page/solution/fashion.vue"
import Aimake from "./page/solution/aimake.vue"
import Custom from "./page/solution/custom.vue"
import Ordersystem from "./page/solution/ordersystem.vue"
import Serve from "./page/solution/serve.vue"

import Newsdetails from "./page/news/details.vue"
import Newsdetails1 from "./page/news/details1.vue"
import Newsdetails2 from "./page/news/details2.vue"
import Newsdetails3 from "./page/news/details3.vue"
import Newsdetails4 from "./page/news/details4.vue"

import Newlist from "./page/news/list.vue"

import About from "./page/about/about.vue"
import Abouthr from "./page/about/hr.vue"
import Aboutcontact from "./page/about/contact.vue"

const routes = [{
		path: "/",
		component: Index
	},
	{
		path: "/home",
		component: Index
	},
	{
		path: "/newpro/Proclub",
		component: Proclub
	},
	{
		path: "/newpro/ProaiLiuxing",
		component: Proailiuxing
	},
	{
		path: "/newpro/Prodesgin",
		component: Prodesgin
	},
	{
		path: "/newpro/Prodatapr",
		component: Prodatapr
	}, {
		path: "/newpro/Probookclub",
		component: Probookclub
	},
	{
		path: "/newpro/Prointenet",
		component: Prointenet
	},
	{
		path: "/newpro/Pro3d",
		component: Pro3d
	},
	{
		path: "/Supply",
		component: Supply
	},
	{
		path: "/Solution/Aimake",
		component: Aimake
	},
	{
		path: "/Solution/Custom",
		component: Custom
	},
	{
		path: "/Solution/Fashion",
		component: Fashion
	},
	{
		path: "/Solution/Ordersystem",
		component: Ordersystem
	},
	{
		path: "/Solution/Serve",
		component: Serve
	},
	{
		path: "/News/List",
		component: Newlist
	},
	{
		path: "/About",
		component: About
	},
	{
		path: "/About/Hr",
		component: Abouthr
	},
	{
		path: "/About/Contact",
		component: Aboutcontact
	},	
	{
		path: "/News/Details/test1",
		component: Newsdetails
	},
 
	,
	{
		path: "/News/Details/1",
		component: Newsdetails1
	},
	,
	{
		path: "/News/Details/2",
		component: Newsdetails2
	},
	,
	{
		path: "/News/Details/3",
		component: Newsdetails3
	},
	,
	{
		path: "/News/Details/4",
		component: Newsdetails4
	},


]





export default routes;
